import getLocaleProperty from './getLocaleProperty'

/**
 * Returns the locale description expression of the thing.
 * @param {Thing} thing - The thing reference.
 * @param {string} lang - The lang of the expression.
 * @param {string} defaultLang - The lang of the expression.
 * @return {string} The locale description expression of the thing.
 */
const getLocaleDescription = getLocaleProperty('description' ) ;

export default getLocaleDescription ;
